module.exports = __webpack_public_path__ + "img/map-step_2.6a7b1e0.webp";